<template>
    <!--    <form ref="form" @submit.prevent>-->
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">권한구성</span>
            <span class="txt">직원들의 권한을 어떻게 분류할지 설정합니다.</span>
        </div>
        <div class="com-author-table">
            <div class="com-btn-area">
                <div class="left-box">
                    <span v-if="isEditing" class="txt red">최대 10개까지 등록 가능합니다.</span>
                </div>
                <div class="right-box">
                    <button class="com-btn white" type="button" @click="isEditing = !isEditing">수정</button>
                    <button class="com-btn" type="button" @click="add">+ 추가</button>
                </div>
            </div>
            <table class="grade-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 350px" />
                    <col style="width: 160px" />
                    <col style="width: 210px" />
                </colgroup>
                <thead>
                    <tr class="top-header">
                        <th></th>
                        <th>직급명</th>
                        <th>권한구성</th>
                        <th></th>
                    </tr>
                    <tr v-if="!isLoading && data.length > 0" class="header">
                        <th>최고권한</th>
                        <th class="left">
                            <span v-if="!isEditing">{{ list[0].roleName }}</span>
                            <input v-else v-model="list[0].roleName" class="w100p" required type="text" />
                        </th>
                        <th>
                            <router-link
                                :to="{ name: 'SettingAuthorDetail', params: { roleId: list[0].roleId } }"
                                class="link"
                            >
                                상세보기 &gt;
                            </router-link>
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="isLoading">
                    <tr>
                        <td colspan="4">
                            <loading-spinner />
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <template v-for="(item, index) in list">
                        <tr v-if="index > 0 && index < data.length - 0" :key="index">
                            <td v-if="item.roleId == undefined"></td>
                            <td v-else>
                                <button
                                    :style="{ visibility: index < data.length - 2 ? 'visible' : 'hidden' }"
                                    class="down"
                                    type="button"
                                    @click="down(index)"
                                ></button>
                                <button
                                    :style="{ visibility: index > 1 ? 'visible' : 'hidden' }"
                                    class="up"
                                    type="button"
                                    @click="up(index)"
                                ></button>
                            </td>
                            <td class="left">
                                <span v-if="!isEditing">{{ item.roleName }}</span>
                                <input v-else v-model="item.roleName" class="w100p" required type="text" />
                            </td>
                            <td v-if="item.roleId == undefined"></td>
                            <td v-else>
                                <router-link
                                    :to="{ name: 'SettingAuthorDetail', params: { roleId: item.roleId } }"
                                    class="link"
                                >
                                    상세보기 &gt;
                                </router-link>
                            </td>
                            <td v-if="item.roleId == undefined"></td>
                            <td v-else>
                                <button v-if="!isEditing" class="com-btn blue" type="button" @click="copy(item.roleId)">
                                    권한복제
                                </button>
                                <button class="com-btn" type="button" @click="onClickBtnDeleteRole(item)">삭제</button>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <tfoot v-if="false && !isLoading && data.length > 0">
                    <tr>
                        <td>기본권한</td>
                        <td class="left">
                            <span v-if="!isEditing">{{ list[data.length - 1].roleName }}</span>
                            <input v-else v-model="list[data.length - 1].roleName" class="w100p" required type="text" />
                        </td>
                        <td>
                            <router-link
                                :to="{ name: 'SettingAuthorDetail', params: { roleId: list[data.length - 1].roleId } }"
                                class="link"
                            >
                                상세보기 &gt;
                            </router-link>
                        </td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
            <loading-spinner v-if="isSaving" class="saving-spinner"></loading-spinner>
            <div v-else-if="isEditing" class="bottom-btn">
                <button class="com-btn" type="reset" @click="isEditing = false">취소</button>
                <button class="com-btn blue" type="button" @click="save">저장</button>
            </div>
        </div>
    </div>
    <!--    </form>-->
</template>

<script>
import axios from 'axios';
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { Utils } from '@/assets/js/utils';

export default {
    name: 'SettingAuthor',
    components: { LoadingSpinner },
    props: {},
    computed: {
        list() {
            return this.data.sort((o1, o2) => (o1.roleSeq < o2.roleSeq ? -1 : 1));
        },
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            isLoading: false,
            isEditing: false,
            isSaving: false,
            data: [],
            default: [],
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.isLoading = true;
            api.get(`/admin/api/centerStaffRole/${this.centerId}/all`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    this.default = eval(JSON.stringify(res.data));
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        saveRoleSeq() {
            api.put('/admin/api/centerStaffRole/update/roleSeq', {
                centerId: this.centerId,
                roleIdList: this.list.map((o) => o.roleId),
            }).then((res) => {
                this.$forceUpdate();
            });
        },
        down(index) {
            const list = this.list;
            let replace = list[index].roleSeq;
            list[index].roleSeq = list[index + 1].roleSeq;
            list[index + 1].roleSeq = replace;
            this.saveRoleSeq();
        },
        up(index) {
            const list = this.list;
            let replace = list[index].roleSeq;
            list[index].roleSeq = list[index - 1].roleSeq;
            list[index - 1].roleSeq = replace;
            this.saveRoleSeq();
        },
        add() {
            api.post(`/admin/api/centerStaffRole/custom/${this.centerId}`, {
                centerId: this.centerId,
                roleName: '새로운 직급',
            })
                .then((res) => {
                    this.data.push(res.data);
                })
                .catch((errors) => {
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(errors);
                });
        },
        copy(roleId) {
            const role = this.data.find((o) => o.roleId == roleId);
            if (!role || !confirm(`[${role.roleName}] 권한을 복제하시겠습니까?`)) return;
            this.isLoading = true;
            api.post('/admin/api/centerStaffRole/copyRole', {
                centerId: this.centerId,
                roleId: role.roleId,
                roleName: `${role.roleName}의 복제`,
            })
                .then((res) => {
                    this.isLoading = false;
                    this.load();
                })
                .catch((errors) => {
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(errors);
                });
        },
        save() {
            // if (!this.$refs.form.checkValidity()) {
            //     return;
            // }

            const requests = [];
            this.data.forEach((o) => {
                if (this.default.filter((e) => e.roleId == o.roleId && e.roleName != o.roleName).length > 0) {
                    requests.push(api.put(`/admin/api/centerStaffRole/update/roleName`, o));
                }
            });

            if (requests.length == 0) {
                this.isEditing = false;
                return;
            }

            this.isSaving = true;
            axios
                .all(requests)
                .then(
                    axios.spread((...responses) => {
                        this.isEditing = false;
                        this.isSaving = false;
                        this.load();
                        // this.$forceUpdate();
                    })
                )
                .catch((errors) => {
                    console.error(errors);
                });
        },
        async onClickBtnDeleteRole(role) {
            console.log(role);
            if (!confirm(`"${role.roleName}"권한을 삭제하시겠습니까?`)) {
                return false;
            }

            try {
                const { data } = await this.deleteCenterStaffRole(role.roleId);
                await this.load();
            } catch (e) {
                Utils.alertResponseErrorMessge(e);
            }
        },
        deleteCenterStaffRole(roleId) {
            return api.delete(`/admin/api/centerStaffRole/center/${this.centerId}/delete/role/${roleId}`);
        },
    },
};
</script>
<style lang="scss" scoped>
.spinner-container.saving-spinner {
    height: 120px;
}
</style>
